import { Component, Vue } from 'vue-property-decorator';
import CategoriesDistributionPieCard from '../components/shared/charts/categoriesDistributionPieCard.vue';
import LicensesCountCard from '../components/shared/charts/licensesCountCard.vue';
import LoansCountCard from '../components/shared/charts/loansCountCard.vue';
import LoansDistributionPieCard from '../components/shared/charts/loansDistributionPieCard.vue';
import PurchasesCard from '../components/shared/charts/purchasesCard.vue';
import ResourcesCountCard from '../components/shared/charts/resourcesCountCard.vue';

@Component({
  components: {
    LicensesCountCard,
    LoansCountCard,
    CategoriesDistributionPieCard,
    ResourcesCountCard,
    LoansDistributionPieCard,
    PurchasesCard,
  },
})
export default class extends Vue {}
